import PubSub from 'pubsub-js';
import { isEmail, isEmpty } from 'validator';
import { findIndex } from 'lodash';

const $submitButton = $('.wpcf7-submit');
const $contentForm = $('.content__form');

let errStatus = [];

const disabledSubmitBUtton = (bool) => {
  $submitButton.attr('disabled', bool);
}

const updateStatus = (element, isErr) => {
  const inputName = $(element).data('name');
  const index = findIndex(errStatus, { name: inputName });
  if (isErr) {
    $(element).addClass('err');
    $(element).removeClass('ok');
    errStatus[index].err = true;
  } else {
    $(element).removeClass('err');
    $(element).addClass('ok');
    errStatus[index].err = false;
  }

  const indexErr = findIndex(errStatus, { err: true });
  if (indexErr < 0) {
    disabledSubmitBUtton(false);
  } else {
    disabledSubmitBUtton(true);
  }
}

PubSub.subscribe('init', () => {
  disabledSubmitBUtton(true);

  $('label.required').each((_index, element) => {
    const inputName = $(element).data('name');

    if (inputName === 'message') {
      $('textarea', element).on('input', () => {
        const inputText = $('textarea', element).val();
        if (isEmpty(inputText)) {
          updateStatus(element, true);
        } else {
          updateStatus(element, false);
        }
      });
    } else {
      $('input', element).on('input', () => {
        const inputText = $('input', element).val();
        if (inputName === 'email') {
          if (!isEmail(inputText)) {
            updateStatus(element, true);
          } else {
            updateStatus(element, false);
          }
        } else {
          if (isEmpty(inputText)) {
            updateStatus(element, true);
          } else {
            updateStatus(element, false);
          }
        }
      });
    }

    errStatus.push({
      name: inputName,
      err: true,
    });
  });

  $('label:not(.required)').each((_index, element) => {
    $('input', element).on('input', () => {
      const inputText = $('input', element).val();
      if (inputText) {
        $(element).addClass('ok');
      } else {
        $(element).removeClass('ok');
      }
    });

  });

  const wpcf7Elm = document.querySelector( '.wpcf7' );
 
  wpcf7Elm.addEventListener( 'wpcf7submit', () => {
    $contentForm.addClass('-sent');
  }, false );

  $submitButton.on('click', () => {
    $submitButton.val('送信中…');
    $submitButton.addClass('-sending');
  });
});
